module.exports = __webpack_public_path__ + "img/mp-schedule-item-bg_active.40a145cf.jpg";